import { toFixedRoundedDown } from '@banking/ui/utils/to-fixed-rounded-down';

// NOTE: JS `toPrecision` sets precision digits but does rounding without our control (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toPrecision#return_value)
// Use this method to control the direction of rounding to always be DOWN
// Doesn't support negative number formatting yet

/**
 * E.g. toPrecisionRoundedDown(0.002345, 2) === 0.0023
 * - calculate firstIdxOfNonZero - this is the index of the first non-zero digit, counting from the decimal point. In this example it's the index of 2 which is 2. The reason to subtract 2 is skip 0. at the beginning.
 * - calculate order - the number of decimal places we want to keep. In this example, for 0.002345 and precision two, we want to keep 4 digits after the decimal point.
 * - calculate result string using toFixedRoundedDown
 *
 * E.g. toPrecisionRoundedDown(1.059, 3) === 1.05
 * - calculate order - the number of decimal places we want to keep. In this example, we want to keep 2 digits after the decimal point.
 * - calculate result string using toFixedRoundedDown
 */
export function toPrecisionRoundedDown(number, precision) {
  // Do not support negative number and non-positive precision
  if (number < 0 || precision < 1) {
    return number.toString();
  }
  let order;
  if (number === 0) {
    order = precision - 1;
  } else if (number < 1) {
    const firstIdxOfNonZero = [...number.toString()].findIndex(digit => digit !== '.' && digit !== '0') - 2;
    order = precision + firstIdxOfNonZero;
  } else {
    order = precision - Math.floor(number).toString().length;
  }
  return toFixedRoundedDown(number, order);
}